// src/model/banner.ts
/**
 * Situacao do banner
 */
export enum BannerStatus {
  ENABLED = 'ENABLED',
  DELETED = 'DELETED',
}

export class Banner {
  uuid: string;
  business_unit_uuid?: string;
  title: string;
  source_url: string;
  image_url: string;
  order: number;
  status: BannerStatus;
  created_at: string;
  updated_at: string;
  partner_name: string;
  partner_uuid: string;
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  start_at: string;
  end_at: string;
}
